export { default } from './VerifyEmailModalContent';
